module.exports = __webpack_public_path__ + "static/img/logo.f7944c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 3